
const CompanyStory = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl font-extrabold text-navy mb-6">OUR STORY</h2>
            <div className="h-1 w-24 bg-gold mb-8"></div>
            
            <div className="space-y-6 text-charcoal leading-relaxed">
              <p className="text-lg">
                NS Electrical WA is a newly established electrical contracting company built on a foundation of expertise, 
                dedication, and a commitment to excellence in the Western Australian electrical industry.
              </p>
              
              <p>
                While we're a fresh face in the market, our team brings qualified experience and a modern approach 
                to electrical services. We've launched NS Electrical WA with a clear mission: to provide reliable, 
                compliant, and professional electrical solutions across residential, commercial, and industrial sectors.
              </p>
              
              <p>
                Our startup mentality means we're agile, responsive, and focused on building lasting relationships 
                with our clients. We understand that trust is earned through quality work, transparent communication, 
                and consistent delivery.
              </p>

              <p>
                From day one, we've prioritized safety, compliance with Australian Standards, and customer satisfaction. 
                Every project we undertake is an opportunity to demonstrate our capabilities and grow our reputation 
                in the Western Australian electrical community.
              </p>

              <p className="font-semibold text-navy">
                We're not just starting a business—we're building a trusted electrical service provider for Western Australia.
              </p>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/855f4c2b608d62496f9e5332d427fabe.jpg"
                alt="NS Electrical WA Professional Service"
                className="w-full h-full object-cover object-top"
              />
            </div>
            
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-gold/20 rounded-lg -z-10"></div>
            <div className="absolute -top-6 -left-6 w-48 h-48 bg-navy/10 rounded-lg -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyStory;
